"use client"

import { useMutation } from "@tanstack/react-query"
import {
  submitEnterpriseInquiryAction,
  type EnterpriseInquiryInput,
  type EnterpriseInquiryResult,
} from "@/server-actions/enterprise-inquiry"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { useTranslations } from "next-intl"


export type EnterpriseInquiryMutationInput = EnterpriseInquiryInput & {
  setErrors?: (errors: Record<string, unknown>) => void
}

export function useEnterpriseInquiryMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsEnterpriseInquiry")

  return useMutation({
    mutationFn: async ({
      setErrors,
      ...input
    }: EnterpriseInquiryMutationInput): Promise<EnterpriseInquiryResult> => {
      return withQueryHandling(submitEnterpriseInquiryAction(input), {
        loading: tUi("sendingYourRequest"),
        success: tUi("enterpriseRequestSent"),
        setErrors,
      }) as Promise<EnterpriseInquiryResult>
    },
  })
}
